import React, { useEffect, useState } from "react";
import useUserInfo from "../../../Hooks/useUserInfo";
import { useAudio } from "../../../Providers/AudioProvider";
import matchscedule from "./matchsceduleList";
import { FaCopy, FaShare, FaCheckCircle, FaSearch } from "react-icons/fa";
import { CollegeListForSquadApi, JoinSquadApi, SquadListApi } from "../../../apis/iplBattle";
import Swal from "sweetalert2";
import BattleLeaderBoard from "./LeaderBoard";

function JoinLeague() {
  const { userDetails, updateUserInfo, updatewatchScreenInfo, watchScreen } =
    useUserInfo();
  const playClick = useAudio();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedCollege, setSelectedCollege] = useState("");
  const [showManualInput, setShowManualInput] = useState(true);
  const [LeagueName,setLeagueName]=useState('');
  const [promoPoints, setPromoPoints] = useState(0);
const [collegeList,setCollegeList]=useState([])
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setShowManualInput(!isDropdownOpen);
  };
const [selectedCollegeName ,setSelectedClgName]=useState('')
  const handleSelectCollege = (value, label) => {
    console.log(label,'label');
    
    setSelectedCollege(value);
    setLeagueName('');
    setIsDropdownOpen(false);
    setSelectedClgName(label);
  };
  const handleLeagueName =(e)=>{
    setLeagueName(e.target.value);
    setSelectedCollege("");
    setSelectedClgName("");
  }

  // Check for squadCode in localStorage when component loads
  useEffect(() => {
    const userId = userDetails?.userDetails?.telegramId;
    if (userId) {
      const storedSquadCode = localStorage.getItem(`squadCode_${userId}`);
      if (storedSquadCode) {
        setLeagueName(storedSquadCode);
        // Remove the squad code from localStorage after using it
        localStorage.removeItem(`squadCode_${userId}`);
      }
    }
  }, [userDetails?.userDetails?.telegramId]);

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: matchscedule,
      currentComponentText: "MatchScheduleList",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails?.currentComponent,
          lastComponentText: userDetails?.currentComponentText,
          centerCount: userDetails?.centerCount + 1,
        },
      };
    });
  };
  useEffect(() => {
    const fetchMatchList = async () => {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const result = await CollegeListForSquadApi();
    

      if (result) {
        setCollegeList(result?.data);
        // updatewatchScreenInfo((prev) => ({
        //   ...prev,
        //   current_battle: result?.current_battle,
        // }));
      } else {
        console.log("error in MatchScheduleList APi");
      }
     
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    };

    fetchMatchList();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Generate a random 6-digit code
    // const code = Math.floor(100000 + Math.random() * 900000).toString();
    // setGeneratedCode(code);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    var data = {
      "squadCode" : LeagueName?.toUpperCase()||selectedCollege
      }
    const response = await JoinSquadApi(data);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));
    if (response?.success) {
      Swal.fire({
        text: "Joined league successfully!",
        icon: "success",
        confirmButtonText: "OK",
      }).then((confirm) => {
        if (confirm) {
         goToThePage(BattleLeaderBoard,'BattleLeaderBoard')
        }
    });
    } else {
      Swal.fire({
        title: "Error!",
        text: response?.error,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  const [searchTerm, setSearchTerm] = useState("");

  // Filter the list based on the search term
  const filteredColleges = collegeList?.filter((option) =>
    option?.squadName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getSliderBackground = () => {
    const percentage = ((promoPoints - 500) / (10000 - 500)) * 100;
    return `linear-gradient(to right, 
      #09BD1B 0%, 
      #09BD1B ${percentage}%, 
      #2c2c2c ${percentage}%, 
      #2c2c2c 100%)`;
  };
  return (
    <>
    <div
      className="games_container p-0 w-100"
      style={{ pointerEvents: "fill" }}
    >
      <img
        onClick={() => {
          toogleMenu(matchscedule, "matchscedule");
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-imgpoints"
        style={{ cursor: "pointer" }}
      />
      <div className="league-container">
      
          <div className="header-title text-center text-uppercase">
            join League
        
        </div>
        <div className="league-content">
          <form className="p-4">
            <div
              className={`input-section ${
                isDropdownOpen ? "input-section-hidden" : ""
              }`}
            >
              <div className="mb-3">
                <label htmlFor="leagueName" className="form-label text-white">
                  League Code
                </label>
                <input
                  type="text"
                  className="form-control text-white"
                  required
                  value={LeagueName}
                  onChange={(e) => handleLeagueName(e)}
                />
              </div>

              <div className="divider-container mb-3">
                <div className="divider-line"></div>
                <span className="divider-text">OR</span>
                <div className="divider-line"></div>
              </div>
            </div>

            <div
              className={`dropdown-section ${
                isDropdownOpen ? "dropdown-section-active" : ""
              }`}
            >
              <div className="mb-3">
                <label className="form-label text-white">
                  Select College League
                </label>
                <div className="custom-dropdown">
                  <div
                    className={` dropdown-join ${
                      isDropdownOpen ? "active" : ""
                    }`}
                    onClick={toggleDropdown}
                  >
                    <span className="selected-text">
                      {selectedCollegeName || "Choose your college league"}
                    </span>
                    <div className="select-arrow"></div>
                  </div>

                  {isDropdownOpen && (
                 <div className="dropdown-container">
                 {/* Search Input */}

                 <input
                   type="text"
                   className="dropdown-search text-uppercase"
                   placeholder="Search college..."
                   value={searchTerm}
                   onChange={(e) => setSearchTerm(e.target.value)}
                 />
              <FaSearch style={{right:"0",width:"100%",left:"40%"}} className="search-icon position-absolute" /> 
                 {/* Dropdown Options */}
                 <div className="dropdown-options">
                   {filteredColleges?.length > 0 ? (
                     filteredColleges?.map((option) => (
                       <div
                         key={option?.squadName}
                         className="dropdown-item borderjoin"
                         onClick={() => handleSelectCollege(option?.squadCode, option?.squadName)}
                       >
                         {option?.squadName}
                       </div>
                     ))
                   ) : (
                     <div className="dropdown-item no-results">No results found</div>
                   )}
                 </div>
               </div>
                  )}
                </div>
              </div>
            </div>

            <div className="d-grid gap-2 sq-btn-container">
              <button type="submit" onClick={handleSubmit} className="sq-btn text-uppercase">
                Join League
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
   
    </>
  );
}

export default JoinLeague;
